import React, {FC} from 'react';
import styled from 'styled-components';
import {LiveShoppingEvent} from '../../../../../grpc_client/grips/protos/shared/live_shopping_event';
import {SimpleButton} from '../../../../../ui/Buttons/SimpleButton';
import Icon, {IconSize} from '../../../../../ui/Icon/Icon';
import {LiveShopping} from '../../../../../ui/Icon/IconName';
import {dropsYellow} from '../../../../../ui/constants/colors';
import {fontSize14, fwBold} from '../../../../../ui/constants/typography';
import {useLiveShoppingPlayerApi} from '../../../context/LiveShoppingPlayerProvider';
import {useLiveShoppingTranslationContext} from '../../../context/TranslationProvider';
import {useComputeEventDetails} from '../../hooks/useComputeEventDetails';

export const LiveEventStartShowButton: FC<{event: LiveShoppingEvent}> = ({
  event,
}) => {
  const {toTheLiveShow, toTheShow} = useLiveShoppingTranslationContext();
  const {isLive, isScheduledAfterToday} = useComputeEventDetails(event);

  const {updateShowIdAndAutoplay} = useLiveShoppingPlayerApi();

  if (isScheduledAfterToday) {
    return null;
  }

  return (
    <StyledButton
      onClick={() => updateShowIdAndAutoplay(event.id)}
      data-testid={`ToLiveShowButton-${event.id}`}
    >
      <StyledButtonIcon asset={LiveShopping.IcPlayYellow} size={IconSize.S} />
      <ButtonText>{isLive ? toTheLiveShow : toTheShow}</ButtonText>
    </StyledButton>
  );
};

export const StyledButton = styled(SimpleButton)`
  color: ${dropsYellow};
`;

export const ButtonText = styled.span`
  ${fontSize14};
  ${fwBold};
  padding-left: 5px;
`;

const StyledButtonIcon = styled(Icon)``;
